import React, { useEffect } from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { Button, Grid, Card, CardContent, CardHeader } from '@mui/material';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { RHFTextField, FormProvider, RHFSelectField } from '../../common/hook-form';
import PageTitle from '../../components/PageTitle';
import { apiConstants, getGeneric, patchGeneric } from '../../common/constants';
import AddIcon from "@mui/icons-material/Add";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useSnackbar } from 'notistack';
import { useGetAllCourierPartnersCachedQuery } from '../../redux/commonApiCalls';
import _ from 'lodash';

const CourierConfig = () => {
    
    const andfilter = [{ "field": "is_deleted", "operator": "eq", "value": '0' }];
    const filter = {
        "andfilter": andfilter,
        "offset": 0,
        "limit": 1000,
        "skipCount": true,
        "includes": "id,name,cpAccountCode,prozoId,supportedShipmentType,isBlended,type,cp_id"
    }
    const { data: courierList } = useGetAllCourierPartnersCachedQuery(filter);

    const { enqueueSnackbar } = useSnackbar();
    const method = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                courier: Yup.string().required("Please select courier"),
                isRvpReasonConfigEnabled: Yup.string().required("Please select"),
                // list: Yup.array().of(
                //     Yup.object().shape({
                //         reasonName: Yup.string().required("Reason Name is required")
                //     })
                // )
            })
        ),
        defaultValues: {
            courier: '',
            isRvpReasonConfigEnabled: '',
            list: [
                {
                    reasonCode: '',
                    reasonName: ''
                },
            ],
        }
    });

    const {
        handleSubmit,
        reset,
        watch,
        control,
        setValue
    } = method;
    const { fields, append, remove } = useFieldArray({
        control,
        name: "list"
    });

    const onSubmit = (data) => {
        const payload = {
            "prozoId": data.courier,
            "rvpReasonConfig": data.list.map((item, index) => ({
                ...item,
                reasonCode: `${Math.random().toString(36).substring(2, 4).toUpperCase()}${index.toString().padStart(2, '0')}`
            })),
            "isRvpReasonConfigEnabled": data.isRvpReasonConfigEnabled,
        }
        patchGeneric(apiConstants.CONFIG_COURIER_UPDATE, payload).then((res) => {
            enqueueSnackbar("Successfully Updated", { variant: 'success' })
            reset();
        }).catch((err) => {
            enqueueSnackbar(err?.response?.message || "Some error occurred", { variant: 'error' })
            console.log(err);
        })
    };

    const courier = watch('courier');

    useEffect(() => {
        if (courier) {
            getGeneric(`${apiConstants.GET_COURIER_CONFIG_BY_PROZO_ID}/?prozoId=${courier}`).then((res) => {
                console.log(Object.keys(res.data));

                if (res?.data && Object.keys(res.data).length > 0) {
                    setValue('isRvpReasonConfigEnabled', res?.data?.isRvpReasonConfigEnabled);
                    remove();
                    const reasonConfig = res?.data?.rvpReasonConfig || [];
                    reasonConfig.forEach((item) => {
                        append({
                            reasonName: item.reasonName || ''
                        });
                    });
                } else {
                    setValue('isRvpReasonConfigEnabled', '');
                    remove();
                    append({
                        reasonName: ''
                    })
                }
            })
        }
    }, [courier])

    //PROZOID 
    return (
        <>
            <PageTitle>Courier Configuration</PageTitle>
            <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
                <Card sx={{ boxShadow: '0 1px 3px rgba(0,0,0,0.05)', borderRadius: '8px' }}>
                    <CardHeader
                        title="RVP Reason Configuration"
                        subheader="Configure return reasons for specific couriers. Add or remove reasons as needed."
                    />
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                                 <RHFSelectField
                                    width="100%"
                                    name="courier"
                                    label="Select CP Account Code"
                                    options={_.orderBy(courierList, 'name').map(val => ({
                                        value: val.prozoId,
                                        label: val.prozoId
                                    }))}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <RHFSelectField
                                    width="100%"
                                    name="isRvpReasonConfigEnabled"
                                    label={`Enable RVP Reason Config`}
                                    options={
                                        [{
                                            value: true,
                                            label: "Enable",
                                        }, {
                                            value: false,
                                            label: "Disable",
                                        }]
                                    }
                                />
                            </Grid>
                            {fields.map((field, index) => {
                                return (
                                    <React.Fragment key={field.id}>
                                        <Grid container spacing={2} sx={{ mt: 1, ml: 0.6 }}>
                                            <Grid item xs={6}>
                                                <RHFTextField
                                                    name={`list.${index}.reasonName`}
                                                    label="Reason Name"
                                                />
                                            </Grid>
                                            {
                                                fields.length !== 1 && (
                                                    <Grid item xs={2}>
                                                        <Button
                                                            onClick={() => remove(index)}
                                                            color="error"
                                                            variant="contained"
                                                            startIcon={<RemoveCircleOutlineIcon />}
                                                            size="small"
                                                            sx={{ mt: 1, borderRadius: 1 }}
                                                        >
                                                            Remove
                                                        </Button>
                                                    </Grid>
                                                )
                                            }
                                            {fields.length === index + 1 && (
                                                <Grid item xs={2}>
                                                    <Button
                                                        onClick={() =>
                                                            append({
                                                                reasonCode: '',
                                                                reasonName: ''
                                                            })
                                                        }
                                                        variant="contained"
                                                        startIcon={<AddIcon />}
                                                        size="small"
                                                        sx={{ mt: 1, borderRadius: 1 }}

                                                    >
                                                        Add
                                                    </Button>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </React.Fragment>
                                )
                            })}

                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" size="small"
                                    sx={{ bgcolor: '#1565c0', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#0d47a1' } }}>
                                    Submit
                                </Button>
                                <Button variant="contained" size="small" onClick={() => { reset(); }}
                                    sx={{ ml: 1, bgcolor: '#ef4444', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#dc2626' } }}>
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </FormProvider>
            <QCReturnReasonConfig courierList={courierList} />
            <CourierConfigPincode courierList={courierList} />
        </>
    );
};

export default CourierConfig;

const CourierConfigPincode = ({ courierList }) => {
    const { enqueueSnackbar } = useSnackbar();
    const method = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                courier: Yup.string().required("Please select courier"),
                blockedPincodes: Yup.mixed().test(
                    'valid-pincodes',
                    'Pincodes must be 6 digits and comma-separated',
                    (value) => {
                        if (!value) return true; // Allow empty value
                        const pincodes = Array.isArray(value) ? value : value.split(',').map(pin => pin.trim());
                        return pincodes.every(pin => /^\d{6}$/.test(pin));
                    }
                ),
            })
        ),
        defaultValues: {
            courier: '',
            blockedPincodes: [],
        }
    });

    const {
        handleSubmit,
        reset,
        watch,
        setValue
    } = method;

    const onSubmit = (data) => {
        const payload = {
            "prozoId": data.courier,
            "blockedPincodes": data.blockedPincodes.split(','),
        }
        patchGeneric(apiConstants.CONFIG_COURIER_UPDATE, payload).then((res) => {
            enqueueSnackbar("Successfully Updated", { variant: 'success' })
            reset();
        }).catch((err) => {
            enqueueSnackbar("Some error occurred", { variant: 'error' })
            console.log(err);
        })
    };

    const courier = watch('courier');

    useEffect(() => {
        if (courier) {
            getGeneric(`${apiConstants.GET_COURIER_CONFIG_BY_PROZO_ID}/?prozoId=${courier}`).then((res) => {
                if (res?.data) {
                    setValue('blockedPincodes', res?.data?.blockedPincodes);
                }
            })
        }
    }, [courier])

    return (
        <>
            <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
                <Card sx={{ mt: 4, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', borderRadius: '8px' }}>
                    <CardHeader
                        title="Blocked Pincodes Management"
                        subheader="Configure pincodes that should be blocked for specific couriers. Enter 6-digit pincodes separated by commas."
                    />
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                                 <RHFSelectField
                                    width="100%"
                                    name="courier"
                                    label="Select CP Account Code"
                                    options={_.orderBy(courierList, 'name').map(val => ({
                                        value: val.prozoId,
                                        label: val.prozoId
                                    }))}
                                />
                            </Grid>

                            <Grid item xs={6}>
                                <RHFTextField
                                    width="100%"
                                    name="blockedPincodes"
                                    label={`Blocked Pincodes`}
                                    placeholder="Enter 6-digit pincodes separated by commas"
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" size="small"
                                    sx={{ bgcolor: '#1565c0', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#0d47a1' } }}>
                                    Submit
                                </Button>
                                <Button variant="contained" size="small" onClick={() => { reset(); }}
                                    sx={{ ml: 1, bgcolor: '#ef4444', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#dc2626' } }}>
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </FormProvider>
        </>
    );
};



const QCReturnReasonConfig = ({ courierList }) => {
    const { enqueueSnackbar } = useSnackbar();
    const method = useForm({
        resolver: yupResolver(
            Yup.object().shape({
                courier: Yup.string().required("Please select courier"),
            })
        ),
        defaultValues: {
            courier: '',
            list: [
                {
                    qcReturnReasons: '',
                },
            ],
        }
    });

    const {
        handleSubmit,
        reset,
        watch,
        control,
        setValue
    } = method;
    const { fields, append, remove } = useFieldArray({
        control,
        name: "list"
    });

    const onSubmit = (data) => {
        const payload = {
            "prozoId": data.courier,
            qcReturnReasons: data.list.map(item => item.qcReturnReasons),
        }
        patchGeneric(apiConstants.CONFIG_COURIER_UPDATE, payload).then((res) => {
            enqueueSnackbar("Successfully Updated", { variant: 'success' })
            reset();
        }).catch((err) => {
            enqueueSnackbar(err?.response?.message || "Some error occurred", { variant: 'error' })
            console.log(err);
        })
    };

    const courier = watch('courier');

    useEffect(() => {
        if (courier) {
            getGeneric(`${apiConstants.GET_COURIER_CONFIG_BY_PROZO_ID}/?prozoId=${courier}`).then((res) => {
                if (res?.data?.qcReturnReasons?.length > 0) {
                    const formattedReasons = res.data.qcReturnReasons.map(reason => ({
                        qcReturnReasons: reason
                    }));
                    setValue('list', formattedReasons);
                } else {
                    // If none found, reset to one empty field
                    setValue('list', [{ qcReturnReasons: '' }]);
                }
            });
        }
    }, [courier, setValue]);
    

    //PROZOID 
    return (
        <>
            <PageTitle>Courier Configuration</PageTitle>
            <FormProvider methods={method} onSubmit={handleSubmit(onSubmit)}>
                <Card sx={{ mt: 2, boxShadow: '0 1px 3px rgba(0,0,0,0.05)', borderRadius: '8px' }}>
                    <CardHeader
                        title="QC ClickPost Return Reason Configuration"
                        subheader="Configure return reasons for QC ClickPost."
                    />
                    <CardContent>
                        <Grid container spacing={3}>
                            <Grid item xs={6}>
                                 <RHFSelectField
                                    width="100%"
                                    name="courier"
                                    label="Select CP Account Code"
                                    options={_.orderBy(courierList, 'name').map(val => ({
                                        value: val.prozoId,
                                        label: val.prozoId
                                    }))}
                                />
                            </Grid>
                            {fields.map((field, index) => {
                                return (
                                    <React.Fragment key={field.id}>
                                        <Grid container spacing={2} sx={{ mt: 1, ml: 0.6 }}>
                                            <Grid item xs={6}>
                                                <RHFTextField
                                                    name={`list.${index}.qcReturnReasons`}
                                                    label="QC ClickPost Return Reason"
                                                />
                                            </Grid>
                                            {
                                                fields.length !== 1 && (
                                                    <Grid item xs={2}>
                                                        <Button
                                                            onClick={() => remove(index)}
                                                            color="error"
                                                            variant="contained"
                                                            startIcon={<RemoveCircleOutlineIcon />}
                                                            size="small"
                                                            sx={{ mt: 1, borderRadius: 1 }}
                                                        >
                                                            Remove
                                                        </Button>
                                                    </Grid>
                                                )
                                            }
                                            {fields.length === index + 1 && (
                                                <Grid item xs={2}>
                                                    <Button
                                                        onClick={() =>
                                                            append({
                                                                qcReturnReasons: ''
                                                            })
                                                        }
                                                        variant="contained"
                                                        startIcon={<AddIcon />}
                                                        size="small"
                                                        sx={{ mt: 1, borderRadius: 1 }}

                                                    >
                                                        Add
                                                    </Button>
                                                </Grid>
                                            )}
                                        </Grid>
                                    </React.Fragment>
                                )
                            })}

                            <Grid item xs={12}>
                                <Button type="submit" variant="contained" size="small"
                                    sx={{ bgcolor: '#1565c0', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#0d47a1' } }}>
                                    Submit
                                </Button>
                                <Button variant="contained" size="small" onClick={() => { reset(); }}
                                    sx={{ ml: 1, bgcolor: '#ef4444', color: '#fff', fontSize: '12px', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.5px', px: 2.5, py: 1, '&:hover': { bgcolor: '#dc2626' } }}>
                                    Reset
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </FormProvider>
        </>
    );
};
